
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 49 56","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.354 7.265c-4.018 0-7.573 1.967-9.582 5.297-.464.605-.31 1.362.309 1.816.154.152.463.152.618.152.463 0 .927-.152 1.082-.606 1.545-2.573 4.327-4.086 7.418-4.086.773 0 1.391-.606 1.391-1.363 0-.605-.618-1.21-1.236-1.21z"}}),_c('path',{attrs:{"d":"M48.845 48.735L38.335 25.73c1.855-2.725 3.092-5.903 3.092-9.384C41.427 7.265 33.854 0 24.735 0 15.462 0 7.889 7.416 7.889 16.346c0 3.33 1.081 6.508 2.782 9.081 0 0-.155.151-.155.303L.161 48.735c-.31.454-.155 1.21.309 1.514.464.302 1.082.454 1.545.151l8.965-5.751 1.7 10.443c0 .454.463.908 1.082.908h.154c.464 0 .928-.303 1.237-.757l9.273-20.28 9.273 20.28c.155.454.618.757 1.237.757h.154c.618-.151 1.082-.454 1.082-1.06l1.7-10.443 8.964 5.752c.464.302 1.082.302 1.546-.152.618-.302.773-.908.463-1.362zm-34.31 1.514l-1.237-8.022c0-.454-.31-.757-.773-.908-.463-.151-.927-.151-1.236.151l-6.955 4.39 8.191-18.011c2.628 2.724 6.182 4.389 10.046 4.843l-8.037 17.557zm-4.019-33.903c0-7.568 6.337-13.773 14.064-13.773 7.728 0 14.065 6.205 14.065 13.773 0 7.567-6.337 13.773-14.065 13.773-7.727 0-14.064-6.206-14.064-13.773zm27.202 24.973c-.31-.303-.928-.303-1.237-.151-.464.15-.773.605-.773.908l-1.236 8.021-8.192-17.405A18.123 18.123 0 0036.481 28l8.191 17.86-6.954-4.541z"}})])
          )
        }
      }
    